import { schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import {
  IconAtom,
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
} from '@assets/images/icon';
export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: 'Product Name' }, { text1: 'Mobile Entry' }, { text2: 'Automatic Door Entry' }, { text3: 'Facial Recognition Entry' }],
    },
    {
      data: [
        { text: 'Description' },
        { text: 'A very convenient device that controls the entrance door with a mobile app' },
        { text: 'A convenient device for entry without running the app' },
        { text: 'A device that allows various entries such as face recognition, NFC cards, etc. all at once' },
      ],
    },
    {
      data: [{ text: 'Power Supply' }, { text: 'Battery Use (up to 3 years)' }, { text: 'DC 12V, 24V ' }, { text: 'DC 12V, 3A' }],
    },
  ],

  a: [
    { text: 'Frequency Band', icon: IconSignal },
    { text: 'Communication Range', icon: IconCoil },
    { text: 'Accuracy', icon: IconRuler },
    { text: 'Find Asset', icon: IconSearch },
    { text: 'Angle Measurement', icon: IconRuler },
    { text: 'Precision Tracking', icon: IconAtom },

    { text: 'Power Supply', icon: IconPower },
    { text: 'Battery Consumption', icon: IconEnergyCircle },
    { text: 'Installation Difficulty', icon: IconTools },
    { text: 'Usage Space', icon: IconBuildings },
    { text: 'Recommended<br/>Environment', icon: IconBookmark },
    { text: 'Key Advantages', icon: IconPencil },
    { text: 'External Integration', icon: IconShare },
  ],

  b: [
    { text: '3.1~10.6GHz' },
    { text: '<50m' },
    { text: 'Up to 10cm' },
    { text: '1' },
    { text: '-' },
    { text: '1' },
    { text: 'PoE' },
    { text: 'Medium' },
    { text: '★★★' },
    { text: 'Smart factories, ports' },
    { text: 'Factories, warehouses, shipyards, plants, construction sites, etc.' },
    { text: 'Ultra-precise tracking at cm-level<br/>Operates even in noisy environments' },
    { text: 'API provided' },
  ],
  c: [
    { text: '2.4GHz' },
    { text: '<30m' },
    { text: '10–30cm' },
    { text: '1' },
    { text: '1' },
    { text: '-' },
    { text: 'PoE' },
    { text: 'Low' },
    { text: '★★☆' },
    { text: 'Smart buildings, large indoor areas' },
    { text: 'Offices, hospitals, logistics automation, research facilities' },
    { text: 'Can track nearby tags with a single installation' },
    { text: 'API provided' },
  ],

  d: [
    { text: '2.4GHz' },
    { text: 'Up to 100m' },
    { text: 'Over 10cm' },
    { text: '1' },
    { text: '-' },
    { text: '-' },
    { text: 'PoE' },
    { text: 'Very Low' },
    { text: '★☆☆' },
    { text: 'Warehouses, hospitals, asset management spaces, etc.' },
    { text: 'Large-scale asset management' },
    { text: 'Low deployment cost<br/>Low tag battery consumption' },
    { text: 'API provided' },
  ],

  e: [
    { text: '3.1~10.6GHz' },
    { text: '20m' },
    { text: '10–30cm' },
    { text: '-' },
    { text: '-' },
    { text: '1' },
    { text: 'Rechargeable battery' },
    { text: 'High' },
    { text: '★☆☆' },
    { text: 'Small-scale demos, temporary spaces' },
    { text: 'Temporary sites, small spaces, places where infrastructure construction is difficult' },
    { text: 'No anchor installation required<br/>Highly portable' },
    { text: 'Not provided (app only)' },
  ],
  spec: [
    {},
    {
      image: schemeUwb,
      link: '/en/rtls/uwb',
      title: 'TwinTracker UWB',
      desc: 'UWB',
    },
    {
      image: schemeAoa,
      link: '/en/rtls/aoa',
      title: 'TwinTracker AoA',
      desc: 'BLE + AoA',
    },
    {
      image: schemeBle,
      link: '/en/rtls/ble',
      title: 'TwinTracker BLE',
      desc: 'BLE',
    },
    {
      image: schemeComfort,
      link: '/en/rtls/comfort',
      title: 'Comfort Kit',
      desc: 'UWB',
    },
  ],
};
